import { deepMerge } from "@mantine/core"
import { ValueTuple3 } from "../../../../../@client/System"
import { DepartmentScheduleData } from "../../../../../@client/Theasoft_ApiServer_Orchestra"

function merge<Key1, Key2, T>(
  list: ValueTuple3<Key1, Key2, T>[],
  update: ValueTuple3<Key1, Key2, T>[],
  compare: (
    v1: ValueTuple3<Key1, Key2, T>,
    v2: ValueTuple3<Key1, Key2, T>
  ) => void
) {
  let newData = [...update]
  const data = list.map((v) => {
    const cellData = newData.find((existing) => compare(existing, v))
    if (cellData) {
      newData = newData.filter((v) => v !== cellData)
      return cellData
    } else {
      return v
    }
  })
  return [...data, ...newData] satisfies ValueTuple3<Key1, Key2, T>[]
}

/***
 * returns a copy based on arg0 with updated values of arg1
 */
export function mergeDepartmentScheduleData(
  arg0: DepartmentScheduleData,
  arg1: DepartmentScheduleData
) {
  const formulaResults = merge(
    arg0.formulaResults,
    arg1.formulaResults,
    (v, x) => v[0].contractId == x[0].contractId && v[1].id == x[1].id
  )

  const cellData = { ...arg0.cells, ...arg1.cells }

  const workAreaNeeds = merge(
    arg0.workAreaNeeds,
    arg1.workAreaNeeds,
    (existing, v) => existing[0] == v[0] && existing[1] == v[1]
  )

  const result = {
    ...arg0,
    cells: cellData,
    castByContractIdAndActivityId: deepMerge(
      arg0.castByContractIdAndActivityId,
      arg1.castByContractIdAndActivityId
    ),
    formulaResults,
    workAreaNeeds,
  } satisfies DepartmentScheduleData
  return result
}
